import React from 'react';
import { LEAGUES } from '../utils/constants';

export default function PickHistoryRow({ pick, isLive, activePickGame }) {
  const leagueInfo = LEAGUES[pick.leagueSlug] || {};

  let resultLabel, resultClass;

  if (isLive) {
    // Show live score if game data is available
    if (activePickGame && activePickGame.status === 'in_progress') {
      resultLabel = `${activePickGame.awayTeam?.abbreviation} ${activePickGame.awayScore ?? 0} - ${activePickGame.homeTeam?.abbreviation} ${activePickGame.homeScore ?? 0}`;
    } else {
      resultLabel = 'LIVE';
    }
    resultClass = 'result-live';
  } else {
    resultLabel =
      pick.status === 'won' ? 'W' :
      pick.status === 'lost' ? 'L' :
      pick.status === 'push' ? 'P' : '—';

    resultClass =
      pick.status === 'won' ? 'result-won' :
      pick.status === 'lost' ? 'result-lost' :
      pick.status === 'push' ? 'result-push' : '';
  }

  // streakAfter is the user's streak AFTER this game resolved
  const streakAfter = pick.streakAfter ?? '—';
  const streakDisplay = isLive
    ? '—'
    : pick.status === 'won' && streakAfter > 0
    ? `🔥 ${streakAfter}`
    : pick.status === 'lost'
    ? '💔 0'
    : pick.status === 'push'
    ? `${streakAfter}`
    : `${streakAfter}`;

  return (
    <tr className={`pick-history-row ${resultClass}`}>
      <td className="pick-col-sport">
        <span className="sport-emoji">{leagueInfo.emoji}</span>
        <span className="sport-name">{leagueInfo.shortName || pick.league}</span>
      </td>
      <td className="pick-col-team">
        <div className="pick-team-cell">
          {pick.pickTeamLogo && (
            <img src={pick.pickTeamLogo} alt="" className="pick-team-logo-sm" />
          )}
          <div className="pick-team-text">
            <span className="pick-team-name">{pick.pickTeamName}</span>
            <span className="pick-opponent">vs {pick.opponentTeamName}</span>
          </div>
        </div>
      </td>
      <td className="pick-col-result">
        <span className={`result-badge ${resultClass}`}>{resultLabel}</span>
      </td>
      <td className="pick-col-streak">
        <span className="streak-value">{streakDisplay}</span>
      </td>
    </tr>
  );
}
